export default __webpack_public_path__ + "static/media/archive-icon.7ee14d0c.svg";